var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { convertToBooking, removeLocalAppointmentThunk, removeLocalBookingThunk, updateLocalAppointmentThunk, updateLocalBookingThunk, } from '@spike/bookings-action';
import { showError, showSuccess, showWarning } from '@spike/notifications-action';
import Axios from 'axios';
import values from 'lodash/values';
import { NEW_BOOKINGS_ERROR_ACTION_TYPE, NEW_BOOKINGS_FETCH_ALERTS_START_ACTION_TYPE, NEW_BOOKINGS_FETCH_ALERTS_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_FETCH_AVAILABILITY_START_ACTION_TYPE, NEW_BOOKINGS_FETCH_AVAILABILITY_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_FETCH_PET_SERVICES_START_ACTION_TYPE, NEW_BOOKINGS_FETCH_PET_SERVICES_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_FETCH_SIBLINGS_BOOKINGS_START_ACTION_TYPE, NEW_BOOKINGS_FETCH_SIBLINGS_BOOKINGS_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_FETCH_SLOTS_START_ACTION_TYPE, NEW_BOOKINGS_FETCH_SLOTS_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_RECURRENT_RESCHEDULE_START_ACTION_TYPE, NEW_BOOKINGS_RECURRENT_RESCHEDULE_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_RESET_ACTION_TYPE, NEW_BOOKINGS_SAVE_FOR_DEPOSIT_START_ACTION_TYPE, NEW_BOOKINGS_SAVE_FOR_DEPOSIT_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_SAVE_MULTIPLE_BOOKINGS_FOR_DEPOSIT_START_ACTION_TYPE, NEW_BOOKINGS_SAVE_MULTIPLE_BOOKINGS_FOR_DEPOSIT_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_SAVE_START_ACTION_TYPE, NEW_BOOKINGS_SAVE_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_MULTIPLE_SAVE_START_ACTION_TYPE, NEW_BOOKINGS_MULTIPLE_SAVE_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_SINGLE_RESCHEDULE_START_ACTION_TYPE, NEW_BOOKINGS_SINGLE_RESCHEDULE_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_SINGLE_MULTIPLE_RESCHEDULE_START_ACTION_TYPE, NEW_BOOKINGS_SINGLE_MULTIPLE_RESCHEDULE_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_CHANGE_STATUS_START_ACTION_TYPE, NEW_BOOKINGS_CHANGE_STATUS_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_SAVE_CREATE_START_ACTION_TYPE, NEW_BOOKINGS_SAVE_CREATE_SUCCESS_ACTION_TYPE, NEW_BOOKINGS_NOT_FOUND_ACTION_TYPE, } from './NewBookingsActionsTypes';
import { convertToAvailability, convertToDateSlots, convertToNewBookingAlerts, convertToOrderizableType, convertToPetService, } from './NewBookingsConverter';
var availabilityUrl = 'booking/availability';
var slotsAvailabilityUrl = 'booking/availability_by_hour';
var saveUrl = 'bookings';
var saveRecurringUrl = 'recurring_appointment';
var siblingsBookingsUrl = 'siblings_booking';
var createForDepositUrl = 'booking/create_for_deposits';
var petUrl = 'pet';
var recurrentRescheduleUrl = 'reschedule_appointment';
var singleRescheduleUrl = 'bookings';
var fetchAlerts = 'check_alerts';
var changeStatusUrl = 'booking/change_status';
var appointmentsUrl = "/appointments";
var dateFormat = 'YYYY-MM-DD';
var slotFormat = 'h:mm A';
var HTTP_STATUS_404_NOT_FOUND = 404;
var isLastAvailabilityRequest = function (requestToken, getState) {
    return getState().newBookings.requestTokens.availability === requestToken;
};
var isLastSlotsRequest = function (requestToken, getState) {
    return getState().newBookings.requestTokens.slots === requestToken;
};
var isLastSiblingsBookingsRequest = function (requestToken, getState) {
    return getState().newBookings.requestTokens.siblingsBookings === requestToken;
};
var isLastPetServicesRequest = function (requestToken, getState) {
    return getState().newBookings.requestTokens.petServices === requestToken;
};
var isLastAlertsRequest = function (requestToken, getState) {
    return getState().newBookings.requestTokens.alerts === requestToken;
};
export var resetThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(reset());
            return [2 /*return*/];
        });
    }); };
};
export var fetchAvailabilityThunk = function (apiClientWrapper, petId, serviceId, startDate, endDate) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, url, response, apiError_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchAvailabilityStart(requestToken));
                    url = "".concat(availabilityUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&location_id=").concat((_a = apiClientWrapper.marketplace) === null || _a === void 0 ? void 0 : _a.basics.address.id, "&pet_id=").concat(petId, "&service_id=").concat(serviceId, "&start_date=").concat(startDate.format(dateFormat), "&end_date=").concat(endDate.format(dateFormat));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _b.sent();
                    isLastAvailabilityRequest(requestToken, getState) &&
                        dispatch(fetchAvailabilitySuccess(response.data, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _b.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        dispatch(error());
                        dispatch(showError('Error fetching availability.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchSlotsThunk = function (apiClientWrapper, petId, serviceId, date, slots) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, url, response, apiError_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchSlotsStart(requestToken));
                    url = "".concat(slotsAvailabilityUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&location_id=").concat((_a = apiClientWrapper.marketplace) === null || _a === void 0 ? void 0 : _a.basics.address.id, "&pet_id=").concat(petId, "&service_id=").concat(serviceId, "&start_date=").concat(date.format(dateFormat), "&hours=").concat(encodeURIComponent(slots.map(function (slot) { return slot.format(slotFormat); }).join(',')));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _b.sent();
                    isLastSlotsRequest(requestToken, getState) &&
                        dispatch(fetchSlotsSuccess(response.data, apiClientWrapper.timeZone, slots));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _b.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        dispatch(showError('Error fetching slots.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchSiblingsBookingsThunk = function (apiClientWrapper, clientId, date) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, url, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchSiblingsBookingsStart(requestToken));
                    url = "".concat(siblingsBookingsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId, "&&date=").concat(date.format(dateFormat));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastSiblingsBookingsRequest(requestToken, getState) &&
                        dispatch(fetchSiblingsBookingsSuccess(response.data, clientId, date));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        dispatch(showError('Error fetching siblings bookings.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveThunk = function (apiClientWrapper, clientId, petId, serviceId, date, notes, createdByStaffId, staffId, frequencyId, dateEnd, discount) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(saveStart());
                    url = "".concat(frequencyId ? saveRecurringUrl : saveUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    body = frequencyId
                        ? {
                            marketplace_id: apiClientWrapper.marketplaceId,
                            schedule_frequency_id: frequencyId,
                            schedule_duration_id: 'one_year',
                            appointment: {
                                address_id: apiClientWrapper.marketplace.basics.address.id,
                                customer_id: clientId,
                                pet_id: petId,
                                staff_id: staffId,
                                service_id: serviceId,
                                booked_at: date,
                                booking_end_at: dateEnd,
                                created_by: createdByStaffId,
                                notes: notes,
                                discount_amount: (discount === null || discount === void 0 ? void 0 : discount.amount) || null,
                                discount_percentage: (discount === null || discount === void 0 ? void 0 : discount.percentage) || null
                            },
                        }
                        : {
                            uuid: apiClientWrapper.uuid(),
                            customer_id: clientId,
                            marketplace_id: apiClientWrapper.marketplaceId,
                            staff_id: staffId,
                            appointments_attributes: [
                                {
                                    uuid: apiClientWrapper.uuid(),
                                    address_id: apiClientWrapper.marketplace.basics.address.id,
                                    booked_at: date,
                                    booking_end_at: dateEnd,
                                    customer_id: clientId,
                                    pet_id: petId,
                                    service_id: serviceId,
                                    staff_id: staffId,
                                    created_by: createdByStaffId,
                                    notes: notes,
                                    discount_amount: (discount === null || discount === void 0 ? void 0 : discount.amount) || null,
                                    discount_percentage: (discount === null || discount === void 0 ? void 0 : discount.percentage) || null
                                },
                            ],
                            reschedule: false,
                        };
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _b.sent();
                    dispatch(saveSuccess());
                    handleWarnings((_a = response.data.errors) !== null && _a !== void 0 ? _a : [], dispatch);
                    //@ts-ignore
                    dispatch(updateLocalBookingThunk(response.data.booking, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _b.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        handleError(apiError_4, dispatch, 'Error saving booking.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveMultipleBookingThunk = function (apiClientWrapper, appointments, order, frequencyId, recurringUuid, sendNotification) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_5;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        return __generator(this, function (_r) {
            switch (_r.label) {
                case 0:
                    dispatch(saveMultipleStart());
                    url = "".concat(frequencyId ? saveRecurringUrl : saveUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _r.label = 1;
                case 1:
                    _r.trys.push([1, 3, , 4]);
                    body = frequencyId ?
                        {
                            marketplace_id: apiClientWrapper.marketplaceId,
                            schedule_frequency_id: frequencyId,
                            schedule_duration_id: 'one_year',
                            send_notification: sendNotification,
                            appointment: {
                                address_id: apiClientWrapper.marketplace.basics.address.id,
                                customer_id: (_a = appointments[0]) === null || _a === void 0 ? void 0 : _a.clientId,
                                pet_id: (_b = appointments[0]) === null || _b === void 0 ? void 0 : _b.petId,
                                staff_id: (_c = appointments[0]) === null || _c === void 0 ? void 0 : _c.staffId,
                                service_id: (_d = appointments[0]) === null || _d === void 0 ? void 0 : _d.serviceId,
                                booked_at: (_e = appointments[0]) === null || _e === void 0 ? void 0 : _e.date,
                                booking_end_at: (_f = appointments[0]) === null || _f === void 0 ? void 0 : _f.dateEnd,
                                created_by: (_g = appointments[0]) === null || _g === void 0 ? void 0 : _g.createdByStaffId,
                                notes: (_h = appointments[0]) === null || _h === void 0 ? void 0 : _h.notes,
                                discount_amount: ((_k = (_j = appointments[0]) === null || _j === void 0 ? void 0 : _j.discount) === null || _k === void 0 ? void 0 : _k.amount) || null,
                                discount_percentage: ((_m = (_l = appointments[0]) === null || _l === void 0 ? void 0 : _l.discount) === null || _m === void 0 ? void 0 : _m.percentage) || null,
                                order_item_price: (_o = appointments[0]) === null || _o === void 0 ? void 0 : _o.orderItemPrice,
                                recurring_uuid: recurringUuid,
                            },
                        }
                        : {
                            uuid: apiClientWrapper.uuid(),
                            customer_id: appointments[0].clientId,
                            marketplace_id: apiClientWrapper.marketplaceId,
                            staff_id: appointments[0].staffId,
                            reschedule: false,
                            appointments_attributes: appointments.map(function (appointment) {
                                var _a, _b;
                                return ({
                                    uuid: apiClientWrapper.uuid(),
                                    address_id: apiClientWrapper.marketplace.basics.address.id,
                                    booked_at: appointment.date,
                                    booking_end_at: appointment.dateEnd,
                                    customer_id: appointment.clientId,
                                    pet_id: appointment.petId,
                                    service_id: appointment.serviceId,
                                    staff_id: appointment.staffId,
                                    created_by: appointment.createdByStaffId,
                                    notes: appointment.notes,
                                    discount_amount: ((_a = appointment.discount) === null || _a === void 0 ? void 0 : _a.amount) || null,
                                    discount_percentage: ((_b = appointment.discount) === null || _b === void 0 ? void 0 : _b.percentage) || null,
                                    order_item_price: appointment.orderItemPrice,
                                    recurring_uuid: recurringUuid,
                                });
                            }),
                            order: order ? {
                                marketplace_id: apiClientWrapper.marketplaceId,
                                customer_id: order.customerId,
                                ship_to_customer_id: order.customerId,
                                uuid: apiClientWrapper.uuid(),
                                notes: order.notes,
                                issued_at: order.issuedAt,
                                order_items_attributes: (_p = order.items) === null || _p === void 0 ? void 0 : _p.map(function (item) {
                                    var _a, _b, _c, _d;
                                    return ({
                                        marketplace_id: apiClientWrapper.marketplaceId,
                                        pet_id: item.petId,
                                        order_id: item.orderId,
                                        orderizable_id: (_a = item.orderizable) === null || _a === void 0 ? void 0 : _a.id,
                                        orderizable_type: convertToOrderizableType((_b = item.orderizable) === null || _b === void 0 ? void 0 : _b.type),
                                        staff_id: item.staffId,
                                        uuid: apiClientWrapper.uuid(),
                                        description: item.description,
                                        quantity: item.quantity,
                                        amount: item.amount,
                                        discount_amount: (_c = item.discount) === null || _c === void 0 ? void 0 : _c.amount,
                                        discount_percentage: (_d = item.discount) === null || _d === void 0 ? void 0 : _d.percentage,
                                        started_at: item.startedAt
                                    });
                                })
                            } : undefined,
                        };
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _r.sent();
                    dispatch(saveMultipleSuccess());
                    handleWarnings((_q = response.data.errors) !== null && _q !== void 0 ? _q : [], dispatch);
                    //@ts-ignore
                    dispatch(updateLocalBookingThunk(response.data.booking, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _r.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        dispatch(error());
                        handleError(apiError_5, dispatch, 'Error saving booking.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveForDepositThunk = function (apiClientWrapper, clientId, petId, serviceId, date, notes, appointmentUuid, createdByStaffId, staffId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveForDepositStart());
                    url = "".concat(createForDepositUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = {
                        uuid: apiClientWrapper.uuid(),
                        customer_id: clientId,
                        marketplace_id: apiClientWrapper.marketplaceId,
                        staff_id: staffId,
                        appointments_attributes: [
                            {
                                uuid: appointmentUuid,
                                address_id: apiClientWrapper.marketplace.basics.address.id,
                                booked_at: date,
                                customer_id: clientId,
                                pet_id: petId,
                                service_id: serviceId,
                                staff_id: staffId,
                                created_by: createdByStaffId,
                                notes: notes,
                            },
                        ],
                        reschedule: false,
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveForDepositSuccess(convertToBooking(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!Axios.isCancel(apiError_6)) {
                        dispatch(error());
                        handleError(apiError_6, dispatch, 'Error saving booking for deposit.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveMultipleBookingForDepositThunk = function (apiClientWrapper, appointments, order) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_7;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(saveMultipleBookingForDepositStart());
                    url = "".concat(createForDepositUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    body = {
                        uuid: apiClientWrapper.uuid(),
                        customer_id: appointments[0].clientId,
                        marketplace_id: apiClientWrapper.marketplaceId,
                        staff_id: appointments[0].staffId,
                        reschedule: false,
                        appointments_attributes: appointments.map(function (appointment) {
                            var _a, _b;
                            return ({
                                uuid: apiClientWrapper.uuid(),
                                address_id: apiClientWrapper.marketplace.basics.address.id,
                                booked_at: appointment.date,
                                booking_end_at: appointment.dateEnd,
                                customer_id: appointment.clientId,
                                pet_id: appointment.petId,
                                service_id: appointment.serviceId,
                                staff_id: appointment.staffId,
                                created_by: appointment.createdByStaffId,
                                notes: appointment.notes,
                                discount_amount: ((_a = appointment.discount) === null || _a === void 0 ? void 0 : _a.amount) || null,
                                discount_percentage: ((_b = appointment.discount) === null || _b === void 0 ? void 0 : _b.percentage) || null,
                                order_item_price: appointment.orderItemPrice
                            });
                        }),
                        order: order ? {
                            marketplace_id: apiClientWrapper.marketplaceId,
                            customer_id: order.customerId,
                            ship_to_customer_id: order.customerId,
                            uuid: apiClientWrapper.uuid(),
                            notes: order.notes,
                            issued_at: order.issuedAt,
                            order_items_attributes: (_a = order.items) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                                var _a, _b, _c, _d;
                                return ({
                                    marketplace_id: apiClientWrapper.marketplaceId,
                                    pet_id: item.petId,
                                    order_id: item.orderId,
                                    orderizable_id: (_a = item.orderizable) === null || _a === void 0 ? void 0 : _a.id,
                                    orderizable_type: convertToOrderizableType((_b = item.orderizable) === null || _b === void 0 ? void 0 : _b.type),
                                    staff_id: item.staffId,
                                    uuid: apiClientWrapper.uuid(),
                                    description: item.description,
                                    quantity: item.quantity,
                                    amount: item.amount,
                                    discount_amount: (_c = item.discount) === null || _c === void 0 ? void 0 : _c.amount,
                                    discount_percentage: (_d = item.discount) === null || _d === void 0 ? void 0 : _d.percentage,
                                    started_at: item.startedAt
                                });
                            })
                        } : undefined,
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _b.sent();
                    dispatch(saveMultipleBookingForDepositSuccess(convertToBooking(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    //@ts-ignore
                    dispatch(updateLocalBookingThunk(response.data.booking, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _b.sent();
                    if (!Axios.isCancel(apiError_7)) {
                        dispatch(error());
                        handleError(apiError_7, dispatch, 'Error saving multiple booking for deposit.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchPetServicesThunk = function (apiClientWrapper, petId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, url, response, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchPetServicesStart(requestToken));
                    url = "".concat(petUrl, "/").concat(petId, "/available_services?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastPetServicesRequest(requestToken, getState) &&
                        dispatch(fetchPetServicesSuccess(response.data.available_services.map(function (dto) { return convertToPetService(dto); })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    if (!Axios.isCancel(apiError_8)) {
                        dispatch(error());
                        dispatch(showError('Error fetching pet services.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var recurrentRescheduleThunk = function (apiClientWrapper, appointmentId, date, staffId, serviceId, frequencyId, notes, sendNotification, orderItemPrice, dateEnd, discount) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_9;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(recurrentRescheduleStart());
                    url = "".concat(recurrentRescheduleUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    body = {
                        id: appointmentId,
                        marketplace_id: apiClientWrapper.marketplaceId,
                        booked_at: date,
                        staff_id: staffId,
                        service_id: serviceId,
                        schedule_frequency_id: frequencyId,
                        notes: notes,
                        booking_end_at: dateEnd,
                        discount_amount: (discount === null || discount === void 0 ? void 0 : discount.amount) || null,
                        discount_percentage: (discount === null || discount === void 0 ? void 0 : discount.percentage) || null,
                        order_item_price: orderItemPrice,
                        send_notification: sendNotification,
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _b.sent();
                    dispatch(recurrentRescheduleSuccess());
                    //For a recurrent reschedule, the backend deletes the current bookings and appointments and create new ones.
                    //Because of that the booking and the appointment will be removed and not updated. If it is updated, the web socket removes the
                    //current booking and appointment, but the local update in this function will add it again.
                    //@ts-ignore
                    dispatch(removeLocalBookingThunk(response.data.booking.id));
                    //@ts-ignore
                    dispatch(removeLocalAppointmentThunk(appointmentId));
                    handleWarnings((_a = response.data.errors) !== null && _a !== void 0 ? _a : [], dispatch);
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _b.sent();
                    if (!Axios.isCancel(apiError_9)) {
                        dispatch(error());
                        handleRecurrentRescheduleError(apiError_9, dispatch, 'Error rescheduling.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var singleRescheduleThunk = function (apiClientWrapper, bookingId, appointmentId, date, staffId, serviceId, notes, sendNotification, orderItemPrice, dateEnd, discount, removeEnrollment) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(singleRescheduleStart());
                    url = "".concat(singleRescheduleUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = {
                        id: bookingId,
                        marketplace_id: apiClientWrapper.marketplaceId,
                        appointments_attributes: [
                            {
                                id: appointmentId,
                                booked_at: date,
                                staff_id: staffId,
                                service_id: serviceId,
                                notes: notes,
                                booking_end_at: dateEnd,
                                discount_amount: (discount === null || discount === void 0 ? void 0 : discount.amount) || null,
                                discount_percentage: (discount === null || discount === void 0 ? void 0 : discount.percentage) || null,
                                order_item_price: orderItemPrice,
                                redeem_type: removeEnrollment ? null : undefined,
                                redeem_id: removeEnrollment ? null : undefined,
                            },
                        ],
                        send_notification: sendNotification
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(singleRescheduleSuccess());
                    //@ts-ignore
                    dispatch(updateLocalBookingThunk(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    //@ts-ignore
                    dispatch(updateLocalAppointmentThunk(response.data.appointments.find(function (dto) { return dto.id === appointmentId; }), apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    if (!Axios.isCancel(apiError_10)) {
                        if (apiError_10.response &&
                            apiError_10.response.status === HTTP_STATUS_404_NOT_FOUND) {
                            dispatch(notFound());
                        }
                        else {
                            dispatch(error());
                            handleError(apiError_10, dispatch, 'Error saving appointment.');
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var singleMultipleRescheduleThunk = function (apiClientWrapper, bookingId, appointments, sendNotification) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(singleMultipleRescheduleStart());
                    url = "".concat(singleRescheduleUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = {
                        id: bookingId,
                        marketplace_id: apiClientWrapper.marketplaceId,
                        appointments_attributes: appointments.map(function (appointment) {
                            if (appointment.appointmentId) {
                                return {
                                    id: appointment.appointmentId,
                                    booked_at: appointment.date,
                                    staff_id: appointment.staffId,
                                    service_id: appointment.serviceId,
                                    notes: appointment.notes
                                };
                            }
                            else {
                                return {
                                    uuid: apiClientWrapper.uuid,
                                    address_id: apiClientWrapper.marketplace.basics.address.id,
                                    booked_at: appointment.date,
                                    customer_id: appointment.clientId,
                                    pet_id: appointment.petId,
                                    service_id: appointment.serviceId,
                                    staff_id: appointment.staffId,
                                    created_by: appointment.createdByStaffId,
                                    notes: appointment.notes,
                                };
                            }
                        }),
                        send_notification: sendNotification
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(singleMultipleRescheduleSuccess());
                    //@ts-ignore
                    dispatch(updateLocalBookingThunk(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_11 = _a.sent();
                    if (!Axios.isCancel(apiError_11)) {
                        dispatch(error());
                        handleError(apiError_11, dispatch, 'Error rescheduling.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchAlertsThunk = function (apiClientWrapper, clientId, petId, appointmentDateTime, isRecurring, serviceId, staffId, appointmentId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, marketplaceId, serviceIdParam, staffIdParam, appointmentIdParam, url, response, apiError_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchAlertsStart(requestToken));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    serviceIdParam = serviceId ? "&service_id=".concat(serviceId) : '';
                    staffIdParam = staffId ? "&staff_id=".concat(staffId) : '';
                    appointmentIdParam = appointmentId ? "&appointment_id=".concat(appointmentId) : '';
                    url = "".concat(fetchAlerts, "?marketplace_id=").concat(marketplaceId, "&customer_id=").concat(clientId, "&pet_id=").concat(petId, "&appointment_date_time=").concat(appointmentDateTime.format(), "&recurring=").concat(isRecurring).concat(serviceIdParam).concat(staffIdParam).concat(appointmentIdParam);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastAlertsRequest(requestToken, getState) &&
                        dispatch(fetchAlertsSuccess(convertToNewBookingAlerts(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_12 = _a.sent();
                    if (!Axios.isCancel(apiError_12)) {
                        dispatch(error());
                        dispatch(showError('Error fetching new bookigns alerts.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeBookingStatusThunk = function (apiClientWrapper, bookingId, status, sendSms, sendNotification) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, url, response, apiError_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeBookingStatusStart());
                    queryParams = new URLSearchParams({
                        marketplace_id: apiClientWrapper.marketplaceId.toString(),
                        status: status.toString(),
                        send_sms: (sendSms !== null && sendSms !== void 0 ? sendSms : false).toString(),
                        send_notification: (sendNotification !== null && sendNotification !== void 0 ? sendNotification : false).toString()
                    });
                    url = "".concat(changeStatusUrl, "/").concat(bookingId, "?").concat(queryParams.toString());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, null, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeBookingStatusSuccess());
                    //@ts-ignore
                    dispatch(updateLocalBookingThunk(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_13 = _a.sent();
                    if (!Axios.isCancel(apiError_13)) {
                        dispatch(error());
                        handleError(apiError_13, dispatch, 'Error changing status.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveCreateAppointmentThunk = function (apiClientWrapper, newAppointment) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveCreateStart());
                    url = "".concat(appointmentsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    body = {
                        appointment: newAppointment
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveCreateSuccess(response.data));
                    dispatch(showSuccess("Create appointment service successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_14 = _a.sent();
                    if (!Axios.isCancel(apiError_14)) {
                        dispatch(error());
                        dispatch(showError("Error creating appointment service."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var saveCreateStart = function () {
    return {
        type: NEW_BOOKINGS_SAVE_CREATE_START_ACTION_TYPE,
    };
};
export var saveCreateSuccess = function (newAppointmentDto) {
    return {
        type: NEW_BOOKINGS_SAVE_CREATE_SUCCESS_ACTION_TYPE,
        payload: {
            newAppointment: newAppointmentDto,
        },
    };
};
var fetchAvailabilityStart = function (requestToken) {
    return {
        type: NEW_BOOKINGS_FETCH_AVAILABILITY_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var fetchAvailabilitySuccess = function (dates, timeZone) {
    return {
        type: NEW_BOOKINGS_FETCH_AVAILABILITY_SUCCESS_ACTION_TYPE,
        payload: {
            dates: convertToAvailability(dates, timeZone),
        },
    };
};
var fetchSlotsStart = function (requestToken) {
    return {
        type: NEW_BOOKINGS_FETCH_SLOTS_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var fetchSlotsSuccess = function (dateSlotsDtos, timeZone, requestedSlots) {
    return {
        type: NEW_BOOKINGS_FETCH_SLOTS_SUCCESS_ACTION_TYPE,
        payload: {
            slots: convertToDateSlots(dateSlotsDtos, timeZone, requestedSlots),
        },
    };
};
var fetchSiblingsBookingsStart = function (requestToken) {
    return {
        type: NEW_BOOKINGS_FETCH_SIBLINGS_BOOKINGS_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var fetchSiblingsBookingsSuccess = function (dto, clientId, date) {
    var _a;
    return {
        type: NEW_BOOKINGS_FETCH_SIBLINGS_BOOKINGS_SUCCESS_ACTION_TYPE,
        payload: {
            hasSiblingsBookings: dto.siblings_bookings,
            siblingNames: __spreadArray([], ((_a = dto.pets) !== null && _a !== void 0 ? _a : []), true),
            siblingsClientId: clientId,
            bookingDate: date,
        },
    };
};
var saveStart = function () {
    return {
        type: NEW_BOOKINGS_SAVE_START_ACTION_TYPE,
    };
};
var saveMultipleStart = function () {
    return {
        type: NEW_BOOKINGS_MULTIPLE_SAVE_START_ACTION_TYPE,
    };
};
var saveSuccess = function () {
    return {
        type: NEW_BOOKINGS_SAVE_SUCCESS_ACTION_TYPE,
    };
};
var saveMultipleSuccess = function () {
    return {
        type: NEW_BOOKINGS_MULTIPLE_SAVE_SUCCESS_ACTION_TYPE,
    };
};
var saveForDepositStart = function () {
    return {
        type: NEW_BOOKINGS_SAVE_FOR_DEPOSIT_START_ACTION_TYPE,
    };
};
var saveForDepositSuccess = function (booking) {
    return {
        type: NEW_BOOKINGS_SAVE_FOR_DEPOSIT_SUCCESS_ACTION_TYPE,
        payload: {
            booking: booking,
        },
    };
};
var saveMultipleBookingForDepositStart = function () {
    return {
        type: NEW_BOOKINGS_SAVE_MULTIPLE_BOOKINGS_FOR_DEPOSIT_START_ACTION_TYPE,
    };
};
var saveMultipleBookingForDepositSuccess = function (booking) {
    return {
        type: NEW_BOOKINGS_SAVE_MULTIPLE_BOOKINGS_FOR_DEPOSIT_SUCCESS_ACTION_TYPE,
        payload: {
            booking: booking,
        },
    };
};
var fetchPetServicesStart = function (requestToken) {
    return {
        type: NEW_BOOKINGS_FETCH_PET_SERVICES_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
var fetchPetServicesSuccess = function (petServices) {
    return {
        type: NEW_BOOKINGS_FETCH_PET_SERVICES_SUCCESS_ACTION_TYPE,
        payload: {
            petServices: petServices,
        },
    };
};
var recurrentRescheduleStart = function () {
    return {
        type: NEW_BOOKINGS_RECURRENT_RESCHEDULE_START_ACTION_TYPE,
    };
};
var recurrentRescheduleSuccess = function () {
    return {
        type: NEW_BOOKINGS_RECURRENT_RESCHEDULE_SUCCESS_ACTION_TYPE,
    };
};
var singleRescheduleStart = function () {
    return {
        type: NEW_BOOKINGS_SINGLE_RESCHEDULE_START_ACTION_TYPE,
    };
};
var singleRescheduleSuccess = function () {
    return {
        type: NEW_BOOKINGS_SINGLE_RESCHEDULE_SUCCESS_ACTION_TYPE,
    };
};
var singleMultipleRescheduleStart = function () {
    return {
        type: NEW_BOOKINGS_SINGLE_MULTIPLE_RESCHEDULE_START_ACTION_TYPE,
    };
};
var singleMultipleRescheduleSuccess = function () {
    return {
        type: NEW_BOOKINGS_SINGLE_MULTIPLE_RESCHEDULE_SUCCESS_ACTION_TYPE,
    };
};
var changeBookingStatusStart = function () {
    return {
        type: NEW_BOOKINGS_CHANGE_STATUS_START_ACTION_TYPE,
    };
};
var changeBookingStatusSuccess = function () {
    return {
        type: NEW_BOOKINGS_CHANGE_STATUS_SUCCESS_ACTION_TYPE,
    };
};
var reset = function () {
    return {
        type: NEW_BOOKINGS_RESET_ACTION_TYPE,
    };
};
var error = function () {
    return {
        type: NEW_BOOKINGS_ERROR_ACTION_TYPE,
    };
};
var notFound = function () {
    return {
        type: NEW_BOOKINGS_NOT_FOUND_ACTION_TYPE,
    };
};
var fetchAlertsStart = function (requestToken) {
    return {
        type: NEW_BOOKINGS_FETCH_ALERTS_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken,
        },
    };
};
export var fetchAlertsSuccess = function (alerts) {
    return {
        type: NEW_BOOKINGS_FETCH_ALERTS_SUCCESS_ACTION_TYPE,
        payload: {
            alerts: alerts,
        },
    };
};
var UNPROCESSABLE_ENTITY = 422;
var handleError = function (error, dispatch, genericErrorMessage) {
    var _a, _b;
    console.error({ error: error });
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === UNPROCESSABLE_ENTITY && ((_b = error.response) === null || _b === void 0 ? void 0 : _b.data)) {
        values(error.response.data)
            .flatMap(function (errorMessage) { return errorMessage; })
            .forEach(function (errorMessage) { return dispatch(showError(errorMessage)); });
    }
    else {
        dispatch(showError(genericErrorMessage));
    }
};
var handleRecurrentRescheduleError = function (error, dispatch, genericErrorMessage) {
    var _a, _b;
    console.error({ error: error });
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === UNPROCESSABLE_ENTITY && ((_b = error.response) === null || _b === void 0 ? void 0 : _b.data)) {
        error.response.data
            .flatMap(function (element) { return values(element).flatMap(function (errorMessage) { return errorMessage; }); })
            .forEach(function (errorMessage) { return dispatch(showError(errorMessage)); });
    }
    else {
        dispatch(showError(genericErrorMessage));
    }
};
var handleWarnings = function (errors, dispatch) {
    return errors.forEach(function (errorMessage) { return dispatch(showWarning(errorMessage)); });
};
